import { FC } from 'react';
import { AssetTypeRowCard } from './components/AssetTypeRowCard';
import { useGetFundCodeFromQuery } from '@/modules/invest/hooks/useGetFundCodeFromQuery';
import { useFindFundAssetByFundCode } from '@/modules/invest/subModules/fund/hooks/useFindFundAsset';

export const AssetType: FC = () => {
  const fundCode = useGetFundCodeFromQuery();
  const { fundAsset } = useFindFundAssetByFundCode(fundCode);

  const { assetType } = fundAsset || {};

  const hasAssetType = assetType && assetType.length > 0;

  return hasAssetType ? (
    <div className="flex flex-col gap-y-2">
      {assetType.map((type) => {
        return <AssetTypeRowCard key={type.typeNumber} type={type} />;
      })}
    </div>
  ) : null;
};
